import React, { useRef } from 'react';
import ActionSheet, { useScrollHandlers } from 'react-native-actions-sheet';

import commonProps from '../commonProps';

import MealPlanListRender from './Render';
import { SheetProps } from './types';

type Props = SheetProps & {
  sheetId: string;
};

const MealPlanList = ({ sheetId }: Props) => {
  const sheetRef = useRef();
  const scrollHandlers = useScrollHandlers('mealPlanList', sheetRef);
  return (
    <ActionSheet id={sheetId} ref={sheetRef} {...commonProps}>
      <MealPlanListRender scrollHandlers={scrollHandlers} />
    </ActionSheet>
  );
};

export default MealPlanList;
